import { get, post, put, remove } from '../Services/http';
import { catchError } from './Error.action';
import { show as showNotification } from './Notification.action';
import { toggleLoader } from './GenericGridView.action';
import { getURLSearchParams } from '../Services/url';
import { translate } from '../Services/translation';

export const CART_LOAD = 'CART_LOAD';
export const CART_LOAD_ERROR = 'CART_LOAD_ERROR';
export const CART_RECEIVE = 'CART_RECEIVE';
export const CART_SHOW_INFO = 'CART_SHOW_INFO';
export const CART_HIDE = 'CART_HIDE';
export const CART_UPDATE_DELIVERY_CARTS = 'CART_UPDATE_DELIVERY_CARTS';
export const GENERIC_GRID_ROW_UPDATE = 'GENERIC_GRID_ROW_UPDATE';
export const GENERIC_GRID_VIEW_SET_DATA_TYPE = 'GENERIC_GRID_VIEW_SET_DATA_TYPE';
export const GENERIC_GRID_VIEW_LOAD = 'GENERIC_GRID_VIEW_LOAD';
export const GENERIC_GRID_VIEW_UPDATE_CART_TABS = 'GENERIC_GRID_VIEW_UPDATE_CART_TABS';

export const load = () => (dispatch, getState) => {
    return get('/api/cart')
        .then(response => response.json())
        .then(cart => dispatch(receive(cart)))
        .catch(ex => dispatch(catchError(ex, error => loadError(error))))
        ;
}

export const getCarts = () => (dispatch, getState) => {
    return get('/api/cart/getCarts')
        .then(response => response.json())
        .then(cart => dispatch(receiveDeliveryCarts(cart)))
        .catch(ex => dispatch(catchError(ex, error => loadError(error))));
}


export const clearCart = () => (dispatch, getState) => {
    if (!confirm(translate('common.checkout.confirmtext.clearcart'))) {
        return true;
    }
    dispatch(toggleLoader(true));
    return remove('/api/cart/clearCart')
        .then(response => response.json())
        .then(cart => location.reload())
        .then(cart => dispatch(toggleLoader(false)))
        .catch(ex => dispatch(catchError(ex, error => loadError(error))));
}



export const loadError = error => ({
    type: CART_LOAD_ERROR,
    payload: {
        error,
    }
})

export const receive = cart => ({
    type: CART_RECEIVE,
    payload: cart,
})

export const toggle = () => (dispatch, getState) => {
    dispatch(show(!getState().cart.showInfo));
}

const show = visible => ({
    type: CART_SHOW_INFO,
    payload: {
        showInfo: visible,
    }
})

export const add = ({ articleNumber, quantity = 1, nodeIdToShowNotification = null, notificationMessage = null, hash = '' }) => {
    return (dispatch) => {
        if (!quantity || isNaN(quantity) || parseInt(quantity) <= 0) {
            return;
        }

        return post('/api/cart/add', { articleNumber, quantity: parseInt(quantity) })
            .then(response => response.json())
            .then(cart => {
                dispatch(receive(cart));
                nodeIdToShowNotification && dispatch(showNotification(nodeIdToShowNotification, notificationMessage, hash));
            })
            .catch(ex => dispatch(catchError(ex, error => loadError(error))))
            ;
    }
}

export const reorder = ({ orderId, nodeIdToShowNotification = null, notificationMessage = null, hash = '' }) => {
    if (orderId) {
        return (dispatch) => {
            return post('/api/cart/reorder', { orderId })
                .then(response => response.json())
                .then(cart => {
                    dispatch(receive(cart));
                    nodeIdToShowNotification && dispatch(showNotification(nodeIdToShowNotification, notificationMessage, hash));
                })
                .catch(ex => dispatch(catchError(ex, error => loadError(error))))
                ;
        }
    }
}

export const update = (rowSystemId, quantity, articleNumber) => (dispatch, getState) => {
    return put(`/api/cart/update`, { rowSystemId, quantity, articleNumber })
        .then(response => response.json())
        .then(cart => dispatch(receive(cart)))
        .catch(ex => dispatch(catchError(ex, error => loadError(error))))
        ;
}

const receiveDeliveryCarts = cart => ({
    type: CART_UPDATE_DELIVERY_CARTS,
    payload: {
        deliveryCarts: cart
    },
})

//const receiveDeliveryCartTabs = cartTabs => ({
//    type: CART_UPDATE_DELIVERY_CARTS,
//    payload: {
//        deliveryCartTabs: cartTabs
//    },
//})


export const updateDeliveryCart = (rowSystemId, quantity, articleNumber) => (dispatch, getState) => {
    //alert(JSON.stringify(getState().checkout.payload.deliveryCarts));
    return put(`/api/cart/updateDeliveryCart`, { rowSystemId, quantity, articleNumber })
        .then(response => response.json())
        .then(cart => dispatch(receiveDeliveryCarts(cart)))
        .catch(ex => dispatch(catchError(ex, error => loadError(error))))
        ;
}

